<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
    <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1 v-if="flag != 'edit'">创建设备</h1>
        <h1 v-if="flag == 'edit'">更新设备</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="flag != 'edit'">填写设备的信息。</h3>
          <h3 v-if="flag == 'edit'">更新设备的信息。</h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="名称" prop="name"><br />
            <div class="subheading">输入设备名称，方便辨别设备。最大长度为100个字符</div>
            <el-input v-model="addForm.name" placeholder="请输入" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="设备编号" prop="code"><br />
            <div class="subheading">
              设备编号需唯一，格式为：<b>网关编号_子设备地址号</b><br>
              填写子设备号和网关或自动生成<br>
            </div><br>
            <span>{{addForm.code?addForm.code:'---'}}</span>
          </el-form-item>
          <el-form-item label="设备地址号（HEX）" prop="subCode"><br />
            <div class="subheading">
              设备地址号（HEX）：如设备没有地址号，则为空，默认：01，最大长度为30个字符<br>
            </div>
            <el-input @blur="subCodeBlur" v-model="addForm.subCode" placeholder="请输入" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="关联网关/网关" prop="mduModuleId"><br />
            <div class="subheading">
              请选择设备连接的网关或网关，可搜索网关编号或名称后选择。
            </div>
            <el-select @change="subCodeBlur" v-model="addForm.mduModuleId" filterable :filter-method="dataFilter"
              placeholder="未选择">
              <el-option v-for="item in mduModuleList" :key="item.value" :label="item.label" :value="item.value">
                <span style="float: left;margin-right:20px">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
              </el-option>
            </el-select>
            <el-button @click="refreshModule" icon="el-icon-refresh"></el-button>
          </el-form-item>
          <el-form-item label="设备协议" prop="devProtocolId"><br />
            <div>
              <el-select v-model="addForm.devProtocolId" filterable placeholder="未选择">
                <el-option v-for="item in devProtocolList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-button class="briefBtn" @click="addProtocol">创建协议</el-button>
            </div>
          </el-form-item>


          <div @click="showMore = !showMore"
            style="height:50px;line-height: 50px;padding-left: 20px;color: #409EFF;cursor: pointer;">
            更多设置
            <i v-if="!showMore" class="el-icon-arrow-down el-icon--right" style="margin-left: -2px;"></i>
            <i v-if="showMore" class="el-icon-arrow-up el-icon--right" style="margin-left: -2px;"></i>
          </div>

          <div v-show="showMore">
            <el-form-item label="采集频率">
              <br />
              <div class="subheading">如要主动采集设备数据则需要填写采集频率，不填则不采集</div>
              <el-input v-model="addForm.collectCron" placeholder="请输入cron表达式" autocomplete="off" maxlength="20">
              </el-input>
              <br />
              <div class="subheading">
                Cron表达式填写方式：Cron表达式仅支持5位，不支持秒；
                <br>您可以参考
                <el-button type="text" @click="cronDetail" style="float:none">详细表达式</el-button>
                <el-button type="text" @click="cronConvert" style="float:none">CRON转换器</el-button>
              </div>
            </el-form-item>
            <!-- <el-form-item label="操作系统" prop="os"><br />
            <div class="subheading">请选择网关操作系统。</div>
            <el-select v-model="addForm.os" filterable placeholder="未选择">
              <el-option v-for="item in osList" :key="item.id" :label="item.content" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item label="设备分类" prop="categoryId"><br />
              <div class="subheading">
                请选择设备分类，后续可根据分类进行设备搜索。
              </div>
              <el-cascader expand-trigger="hover" v-model="categoryId" placeholder="未选择" :options="deviceClassList"
                clearable filterable change-on-select></el-cascader>
            </el-form-item>
            <el-form-item label="品牌" prop="brand"><br />
              <div class="subheading">请选择设备品牌，可搜索后选择。</div>
              <el-select v-model="addForm.brand" filterable placeholder="未选择">
                <el-option v-for="item in brandList" :key="item.id" :label="item.content" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="型号" prop="model" v-if="addForm.brand != null"><br />
            <div class="subheading">请选择网关型号，可搜索后选择。</div>
            <el-select v-model="addForm.model" filterable placeholder="未选择" @change="modelChange">
              <el-option v-for="item in modelList" :key="item.id" :label="item.content" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->


            <!-- <el-form-item label="连接方式" prop="linkType"><br />
            <div class="subheading">请选择设备北向连接方式。</div>
            <el-select v-model="addForm.linkType" filterable placeholder="未选择">
              <el-option v-for="item in attendedModeList" :key="item.id" :label="item.content" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->

            <el-form-item class="address" label="位置" prop=""><br />
              <div class="subheading">
                请选择设备具体位置。
              </div>
              <div style="margin-top:10px">
                <el-popover placement="top" v-model="visible">
                  <baidu-map class="bm-view" center="广州市" :zoom="15" @ready="handler" :scroll-wheel-zoom="true"
                    @click="getPoint">
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                    <bm-control>
                      <bm-auto-complete v-model="keyword" :sugStyle="{ zIndex: 999999 }">
                        <el-input size="mini" placeholder="请输入搜索关键字" v-model="keyword"></el-input>
                      </bm-auto-complete>
                    </bm-control>
                    <bm-local-search :keyword="keyword" :auto-viewport="true" @resultshtmlset="resultshtmlset"
                      @searchcomplete="getResults" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
                  </baidu-map>
                  <div style="text-align: right; margin-top: 10px">
                    <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="mapBtnSubmit">确定</el-button>
                  </div>
                  <el-button size="mini" class="briefBtn" slot="reference">地图录入</el-button>
                </el-popover>
                <span class="addressMain">经度：<i>{{ addForm.longitude }}</i></span>
                <span class="addressMain">纬度：<i>{{ addForm.latitude }}</i></span>
                <span class="addressMain">地址：<i>
                    <el-input size="mini" v-model="addForm.location" maxlength="100" style="width: 250%;"></el-input>
                  </i></span>
              </div>
            </el-form-item>
            <el-form-item label="额外参数" prop="parameter"><br />
              <div class="subheading">创建需要额外参数设备时使用。<el-link @click="addParameter" type="primary"
                  style="margin-left:5px">
                  添加参数</el-link>
              </div>
              <div v-for="(parameter, index) in parameters" :key="index">
                <span style="margin-right: 20px">{{'参数'+(index+1)+'：'}}</span>
                <el-input v-model="parameter.key" placeholder="填写参数key值"></el-input>
                <el-input v-model="parameter.value" placeholder="填写参数value值"></el-input>
                <el-button @click.prevent="removeParameter(parameter)">删除</el-button>
              </div>
            </el-form-item>

            <el-form-item label="备注" prop="remarks" style="background-color:#fff"><br />
              <div class="subheading">请简要填写备注。最大长度为255个字符</div>
              <el-input type="textarea" :rows="3" v-model="addForm.remarks" placeholder="请输入" maxlength="255">
              </el-input>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button style="float: right;" v-if="flag != 'edit'" type="primary" @click="onSubmit('addForm',1)">创建并继续
            </el-button>
            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit('addForm',0)">创建</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit('addForm')">更新设备</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {
      return {
        keyword: '',
        subCode: '',
        moduleCode: '',
        routeList: this.$route.meta.routeList,
        flag: this.$route.query.flag,
        rules: {
          name: [{
            required: true,
            message: "请输入设备名称",
            trigger: "blur"
          }],
          // subCode: [{
          //   required: true,
          //   message: "请输入设备编号",
          //   trigger: "blur"
          // }],
          mduModuleId: [{
            required: true,
            message: "请选择关联网关",
            trigger: "change"
          }]

        },
        addForm: {
          subCode: '01',
          model: "",
          code: "",
          devProtocolId: "",
          location: "广州市天河区高普路1035号",
          longitude: 113.417835,
          latitude: 23.177984
        },
        mapInfo: {},
        visible: false,
        showMduProtocolId: true,
        attendedModeList: [], //连接方式下拉数据
        deviceClassList: [], //设备分类下拉数据
        categoryId: [], //设备分类
        agreementList: [], //推荐网关协议数据
        devProtocolList: [], //网关协议下拉数据
        osList: [], //操作系统下拉
        brandList: [], //品牌下拉数据
        mduModule: [],
        mduModuleList: [], //关联网关网关
        brandId: "", //存着当前品牌的id,为了获取推荐协议里面使用
        modelList: [], //型号下拉数据

        //地图部分
        keyword: "", //搜索关键词
        map: null,
        BMap: null,
        center: {
          lng: 113.417835,
          lat: 23.177984
        }, //初始化默认坐标
        zoom: 5, //初始化放大倍数
        searchAddress: null,
        local: null,
        parameters: [{ //额外参数
          key: '',
          value: ''
        }],
        showMore: false //默认不显示更多

      };
    },
    created() { },
    methods: {

      getResults(e) {
        //搜索完，获取第一个结果
        if (e) {
          this.addForm.location = e.keyword;
          if (e.Br && e.Br.length > 0) {
            this.searchAddress = e.Br[0];
          }
        }
      },

      initMarker(lng, lat) {
        //初始化标注点
        this.timeOut = setTimeout(() => {
          //启动定时，避免模态框未及时打开，地图宽高为0，坐标点位于 左上角
          if (!lng) {
            //新增时
            var newPoint = new BMap.Point(113.417835, 23.177984);
            this.map.centerAndZoom(newPoint, 10);
            this.map.clearOverlays(); //清除标注点
          } else {
            var newPoint = new BMap.Point(lng, lat);
            this.map.centerAndZoom(newPoint, 18);
            this.map.clearOverlays(); //清除标注点
            //添加标注
            this.map.addOverlay(new BMap.Marker(newPoint));
          }
        }, 100);
      },

      /**
       * 地图
       * @param BMap
       * @param map
       */
      //初始化
      handler({
        BMap,
        map
      }) {
        this.BMap = BMap;
        this.map = map;
        this.center.lng = 113.417835;
        /*经度*/
        this.center.lat = 23.177984;
        /*维度*/
        this.zoom = 10;
        /*地图显示的层级*/
        var markers = [];
        map.addControl(new BMap.GeolocationControl());
        /*左下角定位功能*/
      },

      refreshModule() {
        let param = {
          commuType: sessionStorage.getItem('commuType')
        };
        API.platformDevDeviceModule(param).then(res => {
          if (res.code == 1) {
            this.mduModuleList = res.data;
            this.mduModule = res.data; //用来自定义搜索

          }
        });
      },
      cronConvert() {
        window.open("http://cron.qqe2.com/");
      },
      cronDetail() {
        window.open("http://crontab.org/");
      },

      //自定义搜索
      dataFilter(val) {
        this.addForm.mduModuleId = val;
        if (val) { //val存在
          this.mduModuleList = this.mduModule.filter((item) => {
            if (!!~item.label.indexOf(val) || !!~item.code.toUpperCase().indexOf(val.toUpperCase()) || !!~item.code
              .indexOf(val) || !!~item.value.toUpperCase().indexOf(val.toUpperCase())) {
              return true
            }
          })
        } else { //val为空时，还原数组
          this.mduModuleList = this.mduModule;
        }
      },
      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        if (this.flag == "edit") {
          let id = this.$route.query.id;
          API.platformDevDeviceView(id).then(res => {
            if (res.code == 1) {

              //根据品牌获取型号下拉数据
              // API.platformDevDeviceModel({
              //   brandId: res.data.brand
              // }).then(
              //   res => {
              //     if (res.code == 1) {
              //       this.modelList = res.data;
              //     }
              //   }
              // );

              let code = res.data.code;
              if (code && code.indexOf('_') != -1) {
                res.data.subCode = code.substring(code.lastIndexOf("_") + 1)
              }
              this.addForm = res.data;
              if (res.data.devOptions && res.data.devOptions.length > 0) { //存在额外参数
                var json = JSON.parse(res.data.devOptions);
                this.parameters = [];
                for (var key in json) { //遍历赋值给parameters
                  var parameter = {
                    key: key,
                    value: json[key]
                  }
                  this.parameters.push(parameter)
                }
              }
              this.categoryId = res.data.categoryIdList;

            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      },
      //获取所有新增页面所有的数据
      getData() {
        //获取设备协议
        this.getProtocolList();
        // //获取操作系统下拉
        // API.platformMduModuleAddData().then(res => {
        //   if (res.code == 1) {
        //     this.osList = res.data.dictionaryList.os;
        //     this.attendedModeList = res.data.dictionaryList.northLinkType
        //   }
        // });
        //获取设备品牌下拉
        API.platformDevDeviceBrand().then(res => {
          if (res.code == 1) {
            this.brandList = res.data.dictionaryList; //品牌下拉数据
          }
        });
        //获取设备分类树形数据
        API.platformDevCategoryDevCategoryList().then(res => {
          if (res.code == 1) {
            this.deviceClassList = res.data.devCategoryTreeList;
          }
        });
        //获取关联网关下拉数据
        this.refreshModule();
        // API.platformDevDeviceLinkTypeArray().then(res => {
        //   if (res.code == 1) {
        //     this.attendedModeList = res.data.dictionaryList;
        //   }
        // });
      },
      //根据品牌下拉数据获取型号
      brandChange(val) {
        this.brandId = val; //把id存起来，为了获取推荐协议里面使用
        this.addForm.model = ""; //品牌改变，型号清空
        API.platformDevDeviceModel({
          brandId: val
        }).then(res => {
          if (res.code == 1) {
            this.modelList = res.data;
          }
        });
      },
      //根据品牌型号，获取推荐协议
      modelChange(val) {
        //传品牌id，跟型号id
        API.platformDevDeviceRecommendProtocol({
          brandId: this.brandId,
          modelId: val
        }).then(res => {
          if (res.code == 1) {
            this.agreementList = res.data;
          }
        });
        this.getProtocolList(); //输入型号之后再挑用查询设备协议数据
      },
      //查询设备协议下拉数据
      getProtocolList() {
        let param = {
          commuType: sessionStorage.getItem('commuType')
        };
        API.platformDevDeviceProtocol(param).then(res => {
          if (res.code == 1) {
            this.devProtocolList = res.data;
          }
        });
      },
      //创建协议
      addProtocol() {
        this.$router.push({
          path: "/equipment/equimentProtocolAdd"
        });
      },
      moduleProtocolDetailsBtn(id) {
        const ids = id;
        this.$router.push({
          path: "/equipment/equimentProtocolDetails",
          query: {
            id: ids
          }
        });
      },
      //创建设备
      onSubmit(formName, flag) {
        let _this = this;
        let _API = API;
        this.addForm.categoryId = this.categoryId && this.categoryId.length > 0 ? this.categoryId[this.categoryId
          .length - 1] : null;
        this.addForm.commuType = sessionStorage.getItem('commuType');
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (_this.parameters.length > 0 && _this.parameters[0].key != "") {
              var parameter = {};
              for (let i = 0; i < _this.parameters.length; i++) {
                if (_this.parameters[i].key != "") {
                  parameter[_this.parameters[i].key] = _this.parameters[i].value;
                }
              }
              _this.addForm.devOptions = JSON.stringify(parameter)
            }
            _API.addPlatformDevDevice(_this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "创建设备成功",
                  type: "success"
                });
                var openNoviceGuide = sessionStorage.getItem("openNoviceGuide") ? sessionStorage.getItem(
                  "openNoviceGuide") : "false";
                var noviceGuideStep = sessionStorage.getItem("noviceGuideStep") ? sessionStorage.getItem(
                  "noviceGuideStep") : '0';
                if (openNoviceGuide == "true" && noviceGuideStep == '3') {
                  this.changeNoviceGuideStep('noviceGuideStep', 4);
                }
                if (flag === 0) {
                  _this.$router.push({
                    path: "/equipment/equipmentManagement"
                  });
                } else {
                  this.addForm = {}
                  this.categoryId = ''
                  this.parameters = []
                }

              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      },
      //更新设备
      editOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.addForm.categoryId = this.categoryId && this.categoryId.length > 0 ? this.categoryId[this.categoryId
          .length - 1] : null;
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (_this.parameters.length > 0 && _this.parameters[0].key != "") {
              var parameter = {};
              for (let i = 0; i < _this.parameters.length; i++) {
                if (_this.parameters[i].key != "") {
                  parameter[_this.parameters[i].key] = _this.parameters[i].value;
                }
              }
              _this.addForm.devOptions = JSON.stringify(parameter)
            }
            _API.editPlatformDevDevice(this.$route.query.id, _this.addForm)
              .then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: "更新设备成功",
                    type: "success"
                  });
                  _this.$router.push({
                    path: "/equipment/equipmentManagement"
                  });
                } else {
                  _this.$message({
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      },
      subCodeBlur(subCode) {
        let _this = this;
        this.mduModuleList.forEach(function (item) {
          if (_this.addForm.mduModuleId == item.value) {
            _this.moduleCode = item.code
            if (_this.addForm.subCode != null && _this.addForm.subCode.trim() != '') {
              _this.addForm.code = _this.moduleCode + "_" + _this.addForm.subCode
            } else {
              _this.addForm.code = _this.moduleCode
            }

          }
        })
      },
      // mduModuleIdChange(mduModuleId) {
      //   let _this = this;
      //   this.mduModuleList.forEach(function (item) {
      //     if (_this.addForm.mduModuleId == item.value) {
      //       _this.moduleCode = item.code
      //       _this.addForm.code = _this.moduleCode + "_" + _this.addForm.subCode
      //     }
      //   })
      // },
      /**
       * 地图
       * @param BMap
       * @param map
       */
      //初始化
      handler({
        BMap,
        map
      }) {
        this.BMap = BMap;
        this.map = map;
      },
      getPoint(e) {
        //点击地图获取一些信息，
        // this.show = true;
        var self = this;
        this.map.clearOverlays();
        let newPoint = e.point;
        //智能搜索
        this.local = new BMap.LocalSearch(this.map, {
          onSearchComplete: this.onSearchComplete
        });
        this.local.search(e.point);
        //清除地图上所有覆盖物
        this.map.clearOverlays();
        this.mapInfo.longitude = newPoint.lng;
        this.mapInfo.latitude = newPoint.lat;
        this.map.centerAndZoom(newPoint, 15);
        //添加标注
        this.map.addOverlay(new BMap.Marker(newPoint));

        var geoc = new BMap.Geocoder();
        geoc.getLocation(e.point, function (rs) { //地址解析
          var addComp = rs.addressComponents;
          self.mapInfo.address = (addComp.province + addComp.city + addComp.district + addComp.street + addComp
            .streetNumber).trim();

        });
      },
      resultshtmlset(e) { //搜索完成，全部原始标注点渲染后，清除标注点，渲染第一个结果的标注点
        if (!this.searchAddress) {
          return false;
        }
        var self = this;
        this.map.clearOverlays();
        let newPoint = this.searchAddress.point;
        this.mapInfo.longitude = newPoint.lng;
        this.mapInfo.latitude = newPoint.lat;
        this.map.centerAndZoom(newPoint, 13);
        //添加标注
        this.map.addOverlay(new BMap.Marker(newPoint))
        var geoc = new BMap.Geocoder();
        geoc.getLocation(newPoint, function (rs) {
          var addComp = rs.addressComponents;
          self.mapInfo.address = self.keyword;
        });

      },
      //地图确认
      mapBtnSubmit() {
        this.addForm.longitude = this.mapInfo.longitude;
        this.addForm.latitude = this.mapInfo.latitude;
        this.addForm.location = this.mapInfo.address;
        this.visible = false;
      },
      //添加额外参数
      addParameter() {
        this.parameters.push({
          key: '',
          value: ''
        })
      },
      //删除额外参数
      removeParameter(item) {
        var index = this.parameters.indexOf(item)
        if (index !== -1) {
          this.parameters.splice(index, 1)
        }
      },
    },
    mounted() {
      this.getData();
      this.getMage();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/equipmentAdd.vue